import { Textarea } from "@/components/ui/textarea";
import { Button } from "@/components/ui/button";
import EvidenceRow from "./EvidenceRow";
import type { EditableClaim, EditableEvidence } from "@/lib/outline-import-types";

interface Props {
  claim: EditableClaim;
  conceptId: string;
  onUpdate: (next: EditableClaim) => void;
  onDrop: () => void;
}

export default function ClaimCard({ claim, conceptId, onUpdate, onDrop }: Props) {
  function updateEvidence(ev_tmp_id: string, patch: Partial<EditableEvidence>) {
    onUpdate({
      ...claim,
      evidence: claim.evidence.map((ev) => ev.tmp_id === ev_tmp_id ? { ...ev, ...patch } : ev),
    });
  }
  return (
    <div id={claim.tmp_id} className="border rounded p-3 mb-3 bg-card text-card-foreground">
      <div className="flex items-start gap-2 mb-2">
        <Textarea
          value={claim.editedText}
          maxLength={500}
          onChange={(e) => onUpdate({ ...claim, editedText: e.target.value.slice(0, 500) })}
          className="flex-1 text-sm"
        />
        <Button variant="ghost" size="sm" aria-label="drop claim" onClick={onDrop}>×</Button>
      </div>
      <div className="space-y-1">
        {claim.evidence.map((ev) => (
          <EvidenceRow
            key={ev.tmp_id}
            evidence={ev}
            conceptId={conceptId}
            onSwap={(paperId, title, authors) => updateEvidence(ev.tmp_id, {
              selectedPaperId: paperId,
              selectedPaperTitle: title,
              selectedPaperAuthors: authors,
            })}
            onSkip={() => updateEvidence(ev.tmp_id, { skipped: true })}
          />
        ))}
      </div>
    </div>
  );
}
